<template>
  <div v-if="isloaded" id="faz-energy-widget" :class="$mq">
    <div class="mm-header">
      <span v-if=!isStorytelling><h1>Energie in Deutschland</h1></span>
      <div v-if=!isStorytelling class="mm-subline">{{ lastChange }}</div>
    </div>
    <div class="energy-flex-container first">

      <div class="energy-box" :class="{twoCol: $mq === 'md'}">
        <div class="energy-headline">Strommix</div>
        <div class="energy-subline">am {{powermixDate}} in Deutschland produziert, in Prozent</div>
        <VDropdown>
          <button class="energy-box-info"></button>
          <template #popper>
            Die Daten zeigen den in Deutschland produzierten Strom und werden täglich automatisiert über eine Schnittstelle, die die Daten der Bundesnetzagentur bereitstellt, abgefragt. Diese stammen aus verschiedenen Quellen, die in Ausnahmefällen nicht termingerecht eingespeist werden. Dann kann es ggfs. zu fehlerhaften bzw. alten Datenständen kommen. Dargestellt sind die prozentualen Anteile der Energieträger relativ zur Gesamtstromerzeugung.
          </template>
        </VDropdown>
        <BarChart
          :data=powermix
          :colors=powerColors
          :barHeight="$mq === 'sm' ? 11 : 15"
          :height="130"
        />
      </div>  

      <div class="energy-box">
        <div class="energy-headline">Strompreis</div>
        <div class="energy-subline">in Cent pro kWh </div>
        <VDropdown>
          <button class="energy-box-info"></button>
          <template #popper>
            Die Daten stammen vom Vergleichsportal Verivox und beziehen sich auf die Preise für Neukunden. Darin enthalten sind alle Kosten für den Stromanschluss, inklusive einer verbrauchsunabhängigen Grundgebühr, Steuern und Abgaben. Referenzgröße ist ein Haushalt mit einem Jahresverbrauch von 4.000 kWh. Die Preise für Bestandskunden fließen nicht in die Berechnung mit ein.
          </template>
        </VDropdown>
        <LineChart
          :data="powerPrice"
          :options="powerChartOptions"
        />
      </div>

      <div class="energy-box">
        <div class="energy-headline">Gasverbrauch</div>
        <div class="energy-subline">in GWh, 7-Tage-Mittel</div>
        <VDropdown>
          <button class="energy-box-info"></button>
          <template #popper>
            Die Daten für den Gasverbrauch stammen von Trading Hub Europe (THE). Für den Gasverbrauch der Privathaushalte wurden die Daten der Standard-Last-Profil-Zähler (SLP) pro Tag summiert. Diese werden für Kunden mit einem Jahresverbrauch bis zu 1.500.000 kWh eingesetzt. Für die Industrie wurde der Verbrauch der RLM-Zähler (Registrierende Leistungsmessung) berechnet. Diese werden ab einem Jahresverbrauch von 1,5 Mio. Kilowattstunden und einer Ausspeiseleistung von 500 kW. eingesetzt.
          </template>
        </VDropdown>
        <div style="max-width: 130px; margin: auto;">
          <StackedColumnChart
          :data="gasUsage"
            :height="$mq === 'sm' ? 100 : 140"
            :font-size="13"
            :baseline="true"
            :elipsis="false"

          />
        </div>
      </div>

      <div class="energy-box">
        <div class="energy-headline">Gasimporte</div>
        <div class="energy-subline">in GWh pro Tag</div>
        <VDropdown>
          <button class="energy-box-info"></button>
          <template #popper>
            Die Daten der Gasimporte stammen von der Bundesnetzagentur (BNetzA) und werden täglich von dieser aktualisiert.
          </template>
        </VDropdown>
        <LineChart
          :data="gasImports"
          :options="gasImportsOptions"
        />
      </div>
     
     
    </div>
    <div v-if=isMoreClicked class="energy-flex-container">

      <div class="energy-box">
        <div class="energy-headline">Dieselpreis</div>
        <div class="energy-subline">in Euro pro Liter</div>
        <VDropdown>
          <button class="energy-box-info"></button>
          <template #popper>
            Die Spritpreis-Daten werden vom Bundeskartellamt an Anbieter von Verbraucher-Informationsdiensten weitergegeben. Einer davon ist das Portal tankerkönig.de, über dessen öffentliche Schnittstelle wir die Daten beziehen. Die Preise basieren auf digitalen Meldungen aller Tankstellen in Deutschland. Wir berechnen aus den Daten den täglichen Durchschnitt aller gemeldeten Preise für Diesel, Super E10 und Super E5.
          </template>
        </VDropdown>
        <LineChart
          :data="dieselPrice"
          :options="fuelChartOptions"
        />
      </div>
       <div class="energy-box">
        <div class="energy-headline">E10-Preis</div>
        <div class="energy-subline">in Euro pro Liter</div>
        <VDropdown>
          <button class="energy-box-info"></button>
          <template #popper>
            Die Spritpreis-Daten werden vom Bundeskartellamt an Anbieter von Verbraucher-Informationsdiensten weitergegeben. Einer davon ist das Portal tankerkönig.de, über dessen öffentliche Schnittstelle wir die Daten beziehen. Die Preise basieren auf digitalen Meldungen aller Tankstellen in Deutschland. Wir berechnen aus den Daten den täglichen Durchschnitt aller gemeldeten Preise für Diesel, Super E10 und Super E5.
          </template>
        </VDropdown>
        <LineChart
          :data="e10Price"
          :options="fuelChartOptions"
        />
      </div>

     <!--  <div class="energy-box">
        <div class="energy-headline">Gasverbrauch</div>
        <div class="energy-subline">in TWh pro Monat</div>
        <div style="max-width: 130px; margin: auto;">
          <ColumnChart
            :data=gasUsage
            :height="$mq === 'sm' ? 110 : 156"
            :font-size="13"
            :baseline="true"
            :elipsis="false"
          />
        </div>
      </div>-->

      <div class="energy-box">
        <div class="energy-headline">Gasspeicher</div>
        <div class="energy-subline">Füllstand in Prozent</div>
        <VDropdown>
          <button class="energy-box-info"></button>
          <template #popper>
            Der Füllstand der deutschen Gasspeicher wird von den Betreiberfirmen laufend an die Plattform AGSI des Verbands GIE gemeldet. Diese Daten fragen wir täglich über eine Schnittstelle ab. Die aktuellsten Daten liegen immer für vorgestern vor. Teilweise handelt es sich dabei noch um Schätzwerte, die im Tagesverlauf korrigiert werden.
          </template>
        </VDropdown>
        <div style="max-width: 130px; margin: auto;">
          <ColumnChart 
            :data=gasStorage
            :height="$mq === 'sm' ? 110 : 156"
            :font-size="13"
            :baseline="true"
            :elipsis="false"
          />
        </div>
      </div>

      <div class="energy-box">
        <div class="energy-headline">Gaspreis</div>
        <div class="energy-subline">in Cent pro kWh</div>
        <VDropdown>
          <button class="energy-box-info"></button>
          <template #popper>
            Die Daten stammen vom Vergleichsportal Verivox und beziehen sich auf die Preise für Neukunden. Darin enthalten sind alle Kosten für den Gasanschluss, inklusive einer verbrauchsunabhängigen Grundgebühr, Steuern und Abgaben. Referenzgröße ist ein Haushalt mit einem Jahresverbrauch von 20.000 kWh. Die Preise für Bestandskunden fließen nicht in die Berechnung mit ein.
          </template>
        </VDropdown>
        <LineChart
          :data="gasPrice"
          :options="gasChartOptions"
        />
      </div>
     

      
     
     
        <span v-if=isStorytelling class="energy-footnote" style="margin-bottom:10px;">{{ lastChange }}</span>     
     
     </div>
     
    <div v-if=!isStorytelling class="energy-nav-container">
    <div class = "ios-bottom" v-if="userAgent === 'uiwebview'"></div>
    <div class="btn_teritary" v-if="!isMoreClicked && userAgent!='uiwebview'" v-on:click="switchContent">
        <svg
          class="icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 25 25"
          fill="none"
          id="background"
          ><path
            d="M15.5,11.5l-3,3l-3-3 M21.5,12.5c0,5-4,9-9,9c-5,0-9-4-9-9c0-5,4-9,9-9C17.5,3.5,21.5,7.5,21.5,12.5z"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div>Mehr anzeigen</div>
      </div>
    
      <div class="en_btn_secondary" onclick="window.open('https://www.faz.net/1.8232227', '_blank'); return false;">Im Detail</div>
      <div class="btn_teritary" v-if=isMoreClicked v-on:click="switchContent">
        <svg
          class="icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 25 25"
          fill="none"
          id="background"
          ><path
            d="M9.5,13.5l3-3l3,3 M21.5,12.5c0,5-4,9-9,9c-5,0-9-4-9-9c0-5,4-9,9-9C17.5,3.5,21.5,7.5,21.5,12.5z"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div>Weniger anzeigen</div>
      </div>
      </div>
  </div>
</template>

<script>
import LineChart from './components/LineChart.vue'
import ColumnChart from './components/ColumnChart.vue'
import BarChart from './components/BarChart.vue'
import StackedColumnChart from './components/StackedColumnChart.vue'
import pym from 'pym.js'
import 'floating-vue/dist/style.css'

const pymChild = new pym.Child()

export default {
  name: 'faz-energy-widget',
  components: {
    LineChart,
    ColumnChart,
    BarChart,
    StackedColumnChart
  },
  data () {
    return {
      isStorytelling:false,
      isMoreClicked:false,
      isloaded: false,
      isInfoClicked: false,
      lastChange:"",
      gasColor:"#2962A3",
      gasColorLight:"##93BCEC",
      gasPrice:[],
      gasUsage: {},
      gasUsageDif: {},
      gasImports: [],
      gasStorage: {},
      dieselColor: "#2962A3",
      dieselPrice: [],
      e10Color:"#2962A3",
      e10Price: [],
      powerColor:"#2962A3",
      powerPrice: [],
      powermix: [],
      powermixDate: null,
      powerColors: [],
      gasFromRussia: [],
      lineChartData: [['dateFormat?','Column A','Column B'], [1,0,5],[2,9,4],[3,1,6],[4,8,3],[5,2,7],[6,7,3],[7,3,6],[8,6,4],[9,4,5],[10,5,1]],
      userAgent: null,
    }
  },
  mounted () {
    

    // Storytelling?
    this.isStorytelling = this.stringToBoolean(document.getElementById("channel").dataset.id)
    if(this.isStorytelling == true){
      this.isMoreClicked = true;
    }

    // Webview?
    var standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test( userAgent ),
      ios = /iphone|ipod|ipad/.test( userAgent );

    if( ios ) {
      if ( !standalone && safari ) {
        this.userAgent = 'safari browser'
      } else if ( standalone && !safari ) {
        this.userAgent = 'standalone'
      } else if ( !standalone && !safari ) {
        this.userAgent = 'uiwebview'
      }
    } else {
      this.userAgent = 'not iOS'
    }

    // Daten holen und aufbereiten


    
    const fuelprice_url = process.env.NODE_ENV == 'development' ? 
      'data/spritpreise.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/energie-widget/spritpreise2.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

    const powerprice_url = process.env.NODE_ENV == 'development' ? 
      'data/strompreis.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/energie-widget/strompreis.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

    const gasstorage_url = process.env.NODE_ENV == 'development' ?  //live-url hier noch anpassen!
      'data/gasfuellstand_2021-now.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/energie-widget/gasfuellstand.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

    const gasprice_url = process.env.NODE_ENV == 'development' ? 
      'data/gaspreis2.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/energie-widget/gaspreis2.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

   /* const gasfromrussia_url = process.env.NODE_ENV == 'development' ? 
      'data/gas_summe.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/energie-widget/gaslieferungen_gesamt.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'
*/
    const gasimports_url = process.env.NODE_ENV == 'development' ? 
      'data/gasimport.json' :
      ' https://cdn.faz-azure.com/multimediaredaktion/energie-widget/gasimport.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

    const powermix_url = process.env.NODE_ENV == 'development' ? 
      'data/strommix.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/energie-widget/strommix.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

    const lastchange_url = process.env.NODE_ENV == 'development' ? 
      'data/timestamp-2.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/energie-widget/timestamp.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

    const powermix_history_url = process.env.NODE_ENV == 'development' ? 
      'data/strommix_infogram.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/energie-widget/strommix_infogram.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

    const gasusage_url = process.env.NODE_ENV == 'development' ? 
      'data/gasverbrauch_widget.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/energie-widget/gasverbrauch_widget.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'


    let fetches = [
      fetch(fuelprice_url).then(r => r.json()), // Spritpreise results[0]
      fetch(powerprice_url).then(r => r.json()), // Strompreise results[1]
      fetch(gasstorage_url).then(r => r.json()), // Gasspeicher Füllstand results[2]
      fetch(gasprice_url).then(r => r.json()), // Gaspreise results[3]
      fetch(gasimports_url).then(r => r.json()), // Gasimporte results[4]
      fetch(powermix_url).then(r => r.json()), // Strommix results[5]
      fetch(lastchange_url).then(r => r.json()), // lezte Änderung results[6]
      fetch(powermix_history_url).then(r => r.json()), // Strommix Historisch? results[7]
      fetch(gasusage_url).then(r => r.json()), // Gasverbrauch results[8]
    ]
    Promise.all(fetches).then((results) => {
      this.isloaded = true;

      console.log("results Strompreise:", results[1])
     
      // Gasverbrauch
      var i = results[8].length-3;
      let usageYear = results[8][0][4].substring(results[8][0][4].length - 4);
      let lastYear = results[8][0][2].substring(results[8][0][2].length - 4);

      var arrGasUsageDif = {
              cols:[{label: 'Kohle', id:'b', color: 'brown'},{label: 'Industrie', id:'c', color: '#2962A3'}, {label: 'Haush./Gew.', id:'a', color: '#93BCEC'}], 
              rows:[[0,results[8][i][2],results[8][i][1]],[0,results[8][i][4],results[8][i][3]]],
              dates: [results[8][i][0]+lastYear, results[8][i][0]+usageYear]
              }

   
      // Spritpreise
      var arrDiesel = [];
      var arrE10 = [];
          results[0].forEach((row) => {       //results[0] sind die Spritpreise (weil die als erstes geholt worden sind)
          arrDiesel.push([row[0], row[3]]); 
          arrE10.push([row[0], row[2]])
        });

      
      

      // Strompreis kann so übergeben werden  
    
        
 
      // Füllstand Gasspeicher
      var gasStorageFirst = results[2][results[2].length-1-365]
      var gasStorageSecond = results[2][results[2].length-1]
      
      var arrGasStorage = {cols:[{label: gasStorageFirst[0], id: 'First', color:'#2962A3'},{label: gasStorageSecond[0], id: 'Second', color:'#93BCEC'}], rows:[[gasStorageFirst[1],gasStorageSecond[1]]]}

      // Gaspreis kann so übergeben werden
      // Gaslieferungen kann auch so übergeben werden.

      this.dieselPrice = arrDiesel;
      this.e10Price = arrE10;

      this.gasStorage = arrGasStorage;
      this.powerPrice = results[1][0].map( row => { 
        return [row[0], String(row[1]).replace(',', '.')]
      })
      console.log("powerPrice:", this.powerPrice);
      this.gasPrice = results[3][0].map( row => { 
        return [row[0], row[1].replace(',','.')] 
      })
      //this.gasPrice = results[3];

      
      
      this.gasImports = results[4];

      
       //results[4].forEach((row) => {       
       //this.gasImports.push([row[0], row[1]]);
       // });


      this.powermix = results[5]
      this.gasUsage = arrGasUsageDif;

      let pColors = {
        'Sonstige': '#2962A3',
        'Sonst.': '#2962A3',
        'Atom': '#2962A3',
        'Gas': '#2962A3',
        'Kohle': '#2962A3',
        'Wind': '#2962A3',
        'Solar': '#2962A3',
        'Biomasse': '#2962A3'}

      this.powerColors = this.powermix.map( row => pColors[row[0]])

      this.lastChange = results[6][0][1][0]

      this.powermixDate = results[7][0].slice(-1)[0][0]
      
    })
    setTimeout(() => {
    this.sendPostMessage(); // iframe height to faz.net
  }, 2000);

  },
  updated () {
  
    pymChild.sendHeight()
    this.sendPostMessage();
    //console.log(pymChild)
    
  },
  methods: {
    sendPostMessage: function () {
      
      var iframeHeight = document.body.scrollHeight;
      console.log("iframeHeight = "+iframeHeight);
      if (iframeHeight) {
        parent.postMessage({ iframeHeight: iframeHeight }, "https://www.faz.net");
      }
  
    },

   stringToFloat: function (val) {
    var a= val.replace(',','.')
    return (parseFloat(a).toFixed(2))
   } ,

   stringToBoolean: function(val) {
      var a = {
        'true': true,
        'false': false
      };
      return a[val];
    },
    
    switchContent: function () {
        this.isMoreClicked = !this.isMoreClicked
        this.sendPostMessage();

      },
    
    switchLayer:function() {
      
      this.isInfoClicked =!this.isInfoClicked

    }

  },
  watch: {

  },
  computed: {
    powerChartOptions: function () {
      return {
        colors: ["#2962A3","#93BCEC","#6FA746","#ed7d38","#a284c7","#edbf57","#c1c1c1","#88a3d6","#f36969","#a5ce81","#ffa46e","#c0a4e2","#ffd882","#d5d5d5",],
        height: this.$mq === 'sm' ? 90 : 135,
        grid: true,
        tooltip: true,
        dot: true,
        fontSize: 13,
        showArea: false,
        showNumber: true,
        lineWidth: 2,
        // axisLabels: ['Jan 2021','jetzt']
      }
    },
    gasChartOptions: function () {
      return {
        colors: ["#2962A3","#93BCEC","#d13d3d","#6FA746","#ed7d38","#a284c7","#edbf57","#c1c1c1","#88a3d6","#f36969","#a5ce81","#ffa46e","#c0a4e2","#ffd882","#d5d5d5",],
        height: this.$mq === 'sm' ? 90 : 135,
        grid: true,
        tooltip: true,
        dot: true,
        fontSize: 13,
        showArea: false,
        showNumber: true,
        lineWidth: 2,
        // axisLabels: ['Jan 2021','jetzt']
      }
    },
     gasImportsOptions: function () {
      return {
        colors: ["#2962A3","#93BCEC","#d13d3d","#6FA746","#ed7d38","#a284c7","#edbf57","#c1c1c1","#88a3d6","#f36969","#a5ce81","#ffa46e","#c0a4e2","#ffd882","#d5d5d5",],
        height: this.$mq === 'sm' ? 90 : 135,
        grid: true,
        tooltip: true,
        dot: true,
        fontSize: 13,
        showArea: false,
        showNumber: true,
        lineWidth: 2,
        showLegend: true,
        legend: ["Alle Gasimporte", "LNG-Importe"]
        // axisLabels: ['Jan 2022','jetzt']
      }
    },
    fuelChartOptions: function () {
      return {
        colors: ['#2962A3',"#93BCEC","#d13d3d","#6FA746","#ed7d38","#a284c7","#edbf57","#c1c1c1","#88a3d6","#f36969","#a5ce81","#ffa46e","#c0a4e2","#ffd882","#d5d5d5",],
        height: this.$mq === 'sm' ? 90 : 135,
        grid: true,
        tooltip: true,
        dot: true,
        fontSize: 13,
        showArea: false,
        showNumber: true,
        lineWidth: 2,
        
        // axisLabels: ['Jan 2021','jetzt']
      }}

  }
}
</script>

<!--style scoped src="./assets/foundation.css">
</style-->

<style lang="scss">
// @import './assets/foundation.css';
@import './assets/style.scss';

.v-popper--theme-dropdown .v-popper__inner {
  font-family: 'MM Source Sans 3', Helvetica, Arial, sans-serif;
  padding: 10px 12px;
  color: var(--mm-white);
  font-size: 13px;
  line-height: 1.3;
  background: var(--mm-grey-300);
  border-radius: 3px;
  box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 300px;
  margin: 0 5px;
  border: none;
}

.v-popper--theme-dropdown .v-popper__arrow-inner {
  border-color: var(--mm-grey-300);
}

.v-popper--theme-dropdown .v-popper__arrow-outer {
  border-color: var(--mm-grey-300);
}

// /* Transition */

// .v-popper--theme-tooltip.v-popper__popper--hidden {
//   visibility: hidden;
//   opacity: 0;
//   transition: opacity .15s, visibility .15s;
// }

// .v-popper--theme-tooltip.v-popper__popper--shown {
//   visibility: visible;
//   opacity: 1;
//   transition: opacity .15s;
// }

// .v-popper--theme-tooltip.v-popper__popper--skip-transition {
//   transition: none !important;
// }
</style>